import React, { Component } from 'react';

export class ContactsApp extends Component {
  render() {
    return <div>Contacts applet goes here.</div>;
  }
}
